// extracted by mini-css-extract-plugin
module.exports = {"container":"boxContainer_container__1QrQN"};